import React from 'react';

const PaymentDetail = ({ParticipantDetail, registryAutorizedUsers}) => {

    var pago = ParticipantDetail.statusPago;
    var esEnLinea = !(pago.idOperacion == undefined || pago.idOperacion == 0);

    // usuarioRegistra guarda el userID del admin que hizo el registro, o
    // "No registrado" cuando se registró en línea sin pasar por un admin
    // (ver EventRegistryPublicForm.jsx/registry-actions.js).
    var usuarioRegistra = ParticipantDetail.usuarioRegistra;
    var registradoPorTexto;
    if (!usuarioRegistra || usuarioRegistra === "No registrado") {
      registradoPorTexto = "En línea (por el atleta)";
    } else {
      var usuario = registryAutorizedUsers && registryAutorizedUsers[usuarioRegistra];
      registradoPorTexto = usuario ? usuario.nombre : usuarioRegistra;
    }

    var filaRegistro = (
      <div className="row">
        <span className="col s12 center-align"><b>Registrado por </b><br/>{registradoPorTexto}</span>
      </div>
    );

    var filaRecuperado = null;
    if (ParticipantDetail.recuperado) {
      var usuarioQueRecupero = registryAutorizedUsers && registryAutorizedUsers[ParticipantDetail.recuperadoPor];
      var nombreQueRecupero = usuarioQueRecupero ? usuarioQueRecupero.nombre : ParticipantDetail.recuperadoPor;
      filaRecuperado = (
        <div className="row">
          <span className="col s12 center-align">
            <b>Este registro incompleto fue recuperado</b><br/>
            Por: {nombreQueRecupero} — {ParticipantDetail.recuperadoFecha}<br/>
            Nuevo registro: {ParticipantDetail.recuperadoComo}
          </span>
        </div>
      );
    }

    var tabla;
    if(!esEnLinea){
      // no descarga detalle de orden por que pago en punto de venta efectivo
      tabla = (<div>
              <div className="row">
              <span className="col s4 m4 l4 center-align"><b>Fecha de pago </b><br/>{pago.fechaPago}</span>
              <span className="col s4 m4 l4 center-align"><b>Forma de inscripcion </b><br/>{pago.formaInscripcion}</span>
              <span className="col s4 m4 l4 center-align"><b>Forma de pago </b><br/>{pago.formaPago}</span>
              </div>
              {filaRegistro}
            </div>);
    }else{
      // descarga detalle de orden

      tabla = (<div>
                <div className="row">
                <span className="col s3 m3 l3 center-align"><b>Fecha de pago </b><br/>{pago.fechaPago}</span>
                <span className="col s3 m3 l3 center-align"><b>Forma de inscripcion </b><br/>{pago.formaInscripcion}</span>
                <span className="col s3 m3 l3 center-align"><b>forma de pago </b><br/>{pago.formaPago}</span>
                <span className="col s3 m3 l3 center-align"><b>id Operación</b><br/>{pago.idOperacion}</span>
                </div>
                {filaRegistro}
            </div>);
    }
    return (
      <>
        {tabla}
        {filaRecuperado}
      </>
    );
}

export default PaymentDetail;
